import wp from '../repos/wp-repo'
import {detectWPCovers} from "../../utils/shared";


var state = {
    page: null,
}

const resource = '/posts'

export default {
    get(opts) {
        let allowedProp = {
            page: null,
            per_page: null,
            slug: null,
        }

        let q = ''
        for (var key in opts) {
            if (key in allowedProp) {
                q += key + '=' + opts[key] + '&';
            }
        }
        q = q.slice(0, -1)

        return wp.get(`${resource}?${q}`)
            .then((res) => {
                detectWPCovers(res.data)
                return res
            });
    }
}
